<template>
	<Transition name="fade" mode="out-in">
	  <div v-if="!loading">
	    <Transition name="fade" mode="out-in">
	      <div key="przeglad" v-if="activeTab === 'przegląd'">
		      <TeamResultsTable
			      :teamId="+WP.team.team_id"
			      :leagueName="WP.team.league"
			      :countryName="WP.team.country"
			      :odds="false"
			      :start-amount="5"
			      :load-no="5"
            expand-analytics="Drużyna ➝ PRZEGLĄD: WIĘCEJ MECZÓW w ostatnie mecze"
			      :rounds="resultsRounds"
			      :countryPolishQueryName="WP.team.query_name ?? ''"/>
	          <h2 class="!text-xl !font-semibold pl-2.5 !mb-[11px] !mt-6 xl:pl-0">Najbliższe mecze</h2>
	        <FootballStatsList v-if="WP.team?.country !== 'World'"
	          class="!mt-0"
	          :round-bottom="upcomingMatches.length < noOfUpcomingMatches && WP.team?.country !== 'World'"
	          :class="{ '!rounded-b-none' : upcomingMatches.length > 0 }"
	          :league="statsListLeague"
            :show-teams-bgs="[+WP.team.team_id]"
	          :matches="upcomingMatches.slice(0, noOfUpcomingMatches)"
	          show-date show-hour show-odds/>
          <FootballLeagueTimetable v-else-if="rounds.length > 0 || Object.keys(rounds).length > 0"
            :countryName="WP.team.country_polish_name"
            redirect-in-header
            :leagueName="WP.team.league"
            :show-teams-bgs="[+WP.team.team_id]"
            :rounds="rounds"
            :countryQueryName="WP.team.country_query_name"/>
          <div v-else class="border-zt-light rounded-zt border">
            <p class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5">
              Brak meczów do wyświetlania
            </p>
          </div>
	        <div v-if="upcomingMatches.length > noOfUpcomingMatches && WP.team?.country !== 'World'"
               class="w-full flex justify-center items-center mb-3 border-b border-x h-[50px] border-zt-light bg-zt-light/35 rounded-b-zt py-4">
	          <button class="h-[17px] flex items-center" @click="noOfUpcomingMatches += 5; countClicks('Drużyna ➝ PRZEGLĄD: WIĘCEJ MECZÓW w najbliższe mecze')">
	            <span class="underline mr-[7px] text-zt-more text-xs font-normal uppercase zt-hover">Rozwiń</span>
	          </button>
	        </div>
          <template v-if="WP.team.country !== 'World'">
            <FootballTable
                class="pt-3"
                :season="WP.team.league_season"
                :seasons-type="WP.team.league_season_type"
                :league-id="WP.team.league_id"
                :selectedTeamsIds="[+WP.team.team_id]"
                page-type="team">
              <template #title>
                <p class="no-default-style !text-xl !font-semibold w-fit flex gap-x-[7px] items-center pl-2.5 xl:pl-0">
                  <span>Tabela - {{ WP.team.league }}</span>
                </p>
              </template>
            </FootballTable>

            <TeamCompareWithLastSeason v-if="highlightedLeaguesIds.includes(+WP.team.league_id)"
                                       class="mt-6"
                                       :team-league-id="+WP.team.league_id"
                                       :team-name="WP.team.team_short_name !== '' ? WP.team.team_short_name : WP.team.name"
                                       :teamId="+WP.team.team_id" />

            <template v-if="WP.team.league_id !== '342'">
            <H2hTable
                class="!mt-0"
                :season="WP.team.league_season"
                :season-type="WP.team.league_season_type"
                :teamId="+WP.team.team_id"/>
            </template>
          </template>
<!--          <football-league-groups v-if="['copa-america','euro'].includes(WP.team.league_query_name)"-->
<!--            :leagueId="WP.team.league_id"-->
<!--            :leagueName="WP.team.league"-->
<!--            :countryName="WP.team.country"-->
<!--            :teamId="WP.team.team_id"-->
<!--            :isOverviewPage="true"-->
<!--            :showSelectGroup="true"-->
<!--            :onMainPage="false"/>-->
          <tournament-qualifications v-if="teamsOtherLeagues.includes('34') || teamsOtherLeagues.includes('32')"
            :country-name="'Świat'"
            :league-id="'1'"
            :initial-region="teamsOtherLeagues.includes('34') ? 34 : 32"
            :team-id="WP.team.team_id"
            :league-name="'Mundial 2026'"
            :league-type="'European Cup'"
            :show-all="false"
            :only-show="'group'" />
		      <football-league-nested-groups v-if="['liga-narodow-uefa'].includes(WP.team.league_query_name)" class="mb-6"
            :leagueId="WP.team.league_id"
            :leagueName="WP.team.league"
            :countryName="WP.team.country"
            :teamId="WP.team.team_id"
            title="Liga Narodów UEFA"
            :isOverview="'true'" />
          <template v-if="['liga-narodow-uefa'].includes(WP.team.league_query_name)">
            <ladder
                :isOverview="'true'"
                show-only-if-team-is-present
                :leagueType="'Cup'"
                :leagueId="WP.team.league_id"
                :leagueName="WP.team.league"
                :countryName="WP.team.country"
                :countryQueryName="WP.team.country_query_name"/>
          </template>
	        <div v-if="+WP.team.league_id === 4 || WP.team.country !== 'World'">
		        <h2 class="!text-xl !font-semibold pl-2.5 !mb-[11px] !mt-6 xl:pl-0">
			        Strzelcy - {{ WP.team.country === 'World' ? WP.team.team_short_name : WP.team.name }}
			        {{ WP.team.league_query_name === 'euro' ? '(EURO 2024)' : '' }}
			        {{ WP.team.league_query_name === 'copa-america' ? '(Copa America 2024)' : ''  }}
		        </h2>
            <div>
              <div v-if="window.size.desktop && multiplePhasesPresent" class="px-2 py-2.5 border-x grid grid-cols-2 gap-x-[44px] border-t rounded-t-zt border-zt-light bg-zt-light-opacity">
                <div class="basis-1/2 w-full text-xs py-[5px] text-center rounded-zt border border-zt-light flex items-center justify-center">
                  <span class="opacity-30">{{ WP.team.league_season }}{{ WP.team.league_season_type === 'season' ? `/${+WP.team.league_season + 1}` : ''}}</span>
                </div>
                <div>
                  <PickFilterModal
                      customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                      custom-header-classes="text-center !text-xs w-full !font-normal"
                      :options="phaseOptions"
                      :defaultOption="selectedPhaseOption.name"
                      :selectedOption="selectedPhaseOption.name"
                      :showIcons="false"
                      slide-bottom-modal
                      :type="'full'"
                      @optionSelected="(option) => selectedPhaseOption = phaseOptions.find(el => el.name === option)"
                  />
                </div>
              </div>
              <div :class="{ 'grid-cols-2' : multiplePhasesPresent, 'rounded-t-zt' : !multiplePhasesPresent || (multiplePhasesPresent && window.size.mobile) }"
                   class="px-2.5 py-3 grid bg-zt-light-opacity gap-x-[7px] border border-zt-light border-b-0 xl:grid-cols-1">
                <PickFilterModal
                    customClasses="bg-zt-light-opacity flex pl-4 items-center
                               border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                    custom-header-classes="text-center !text-xs w-full !font-normal"
                    :options="options"
                    :defaultOption="selected_phase.name"
                    :selectedOption="selected_phase.name"
                    :showIcons="false"
                    :type="'full'"
                    slide-bottom-modal
                    @optionSelected="(option) => selected_phase = options.find(el => el.name === option)"
                />
                <PickFilterModal
                    v-if="window.size.mobile && multiplePhasesPresent"
                    customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                    custom-header-classes="text-center !text-xs w-full !font-normal"
                    :options="phaseOptions"
                    :defaultOption="selectedPhaseOption.name"
                    :selectedOption="selectedPhaseOption.name"
                    :showIcons="false"
                    slide-bottom-modal
                    :type="'full'"
                    @optionSelected="(option) => selectedPhaseOption = phaseOptions.find(el => el.name === option)"
                />
              </div>
            </div>
		        <FootballTabScorersTable class="mb-6"
			        :players="scorers"
			        :pageType="'overview'"
               :phase="selectedPhaseOption.value"
			        :show-only-goals="leaguesWithoutAssists"
              :expand-no="20"
              :show-no="5"
              :table-type="selected_phase.value"/>
	        </div>
		      <div v-if="+WP.team.team_show_squad === 1">
			      <h2 class="!text-xl !font-semibold pl-2.5 !mb-[11px] !mt-6 xl:pl-0">
              Kadra - {{ WP.team.country === 'World' ? WP.team.team_short_name : WP.team.name }}
              {{ WP.team.league_query_name === 'euro' ? '(EURO 2024)' : '' }}
              {{ WP.team.league_query_name === 'copa-america' ? '(Copa America 2024)' : ''  }}
            </h2>
			      <p v-if="squad.length === 0"
               class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5
                      rounded-zt border-zt-light border">
				      Brak informacji do wyświetlenia
			      </p>
			      <TeamSquad v-else :squad="squad" />
		      </div>
	      </div>
	      <div key="tabela" class="!mt-[23px]" v-else-if="activeTab === 'tabela'">
	        <FootballTable
	          :season="WP.team.league_season"
	          :seasons-type="WP.team.league_season_type"
	          :league-id="WP.team.league_id"
	          :selectedTeamsIds="[+WP.team.team_id]"
	          page-type="team">
            <template #title>
              <a :href="`/wyniki-pilka-nozna/${WP.team.country_query_name}/${WP.team.league_query_name}/tabela/`"
                 data-count-click="Klikanie ligi"
                 class="no-default-style !text-xl !font-semibold w-fit zt-hover underline
	                  pl-2.5 xl:pl-0">
                <span>Tabela - {{ WP.team.league }}</span>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="inline-block ml-[7px]" width="22" height="18" viewBox="0 0 22 18" fill="none">
                    <path d="M14.1985 17.255L21.9584 8.62748L14.1985 0L12.9311 1.40907L18.5565 7.63866L4.4375 7.63866L4.4375 9.61631L18.5565 9.61631L12.9311 15.8459L14.1985 17.255Z" fill="white"/>
                    <path d="M1.77877 7.63776H0L0 9.6154H1.77877L1.77877 7.63776Z" fill="white"/>
                  </svg>
		            </span>
              </a>
            </template>
          </FootballTable>
          <TeamCompareWithLastSeason v-if="WP.team?.country !== 'World' && highlightedLeaguesIds.includes(+WP.team.league_id)"
                                     class="mt-6"
                                     :team-league-id="+WP.team.league_id"
                                     :team-name="WP.team.team_short_name !== '' ? WP.team.team_short_name : WP.team.name"
                                     :teamId="+WP.team.team_id" />
          <template v-if="WP.team.league_id !== '342'">
            <H2hTable
                class="!mt-0"
                :season="WP.team.league_season"
                :season-type="WP.team.league_season_type"
                :teamId="+WP.team.team_id"/>
          </template>
	      </div>
	      <div key="wyniki" v-else-if="activeTab === 'wyniki'">
	        <TeamResultsTable
	         :teamId="+WP.team.team_id"
	         :leagueName="WP.team.league"
	         :rounds="resultsRounds"
	         :countryName="WP.team.country"
	         :teamResults="lastMatches"
	         :countryPolishQueryName="WP.team.query_name"/>
	      </div>
	      <div key="terminarz" v-else-if="activeTab === 'terminarz'">
	        <TeamTimetable v-if="WP.team?.country !== 'World'"
	          :rounds="rounds"
	          class="!border-t-0"
	          :teamId="+WP.team.team_id"
	          :leagueName="WP.team.league"
            :show-teams-bgs="[+WP.team.team_id]"
	          :countryName="WP.team.country"
	          :countryPolishQueryName="WP.team.query_name"/>
          <FootballLeagueTimetable v-else
             :countryName="WP.team.country_polish_name"
             :leagueName="WP.team.league"
             redirect-in-header
             :show-teams-bgs="[+WP.team.team_id]"
             :rounds="rounds"
             :countryQueryName="WP.team.country_query_name"/>
	      </div>
	      <div key="strzelcy" v-else-if="activeTab === 'strzelcy'">
          <div v-if="multiplePhasesPresent" class="px-2 py-2.5 border-x grid grid-cols-2 gap-x-[7px] border-t rounded-t-zt border-zt-light bg-zt-light-opacity xl:gap-x-[44px]">
            <div class="basis-1/2 w-full text-xs py-[5px] text-center rounded-zt border border-zt-light flex items-center justify-center">
              <span class="opacity-30">{{ WP.team.league_season }}{{ WP.team.league_season_type === 'season' ? `/${+WP.team.league_season + 1}` : ''}}</span>
            </div>
            <div>
              <PickFilterModal
                  customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                  custom-header-classes="text-center !text-xs w-full !font-normal"
                  :options="phaseOptions"
                  :defaultOption="selectedPhaseOption.name"
                  :selectedOption="singleTablesOptions[0].selectedPhaseOption.name"
                  :showIcons="false"
                  slide-bottom-modal
                  :type="'full'"
                  @optionSelected="(option) => singleTablesOptions[0].selectedPhaseOption = phaseOptions.find(el => el.name === option)"
              />
            </div>
          </div>
          <FootballTabScorersTable class="mb-6"
                                   :players="scorers"
                                   :show-only-goals="leaguesWithoutAssists"
                                   :phase="singleTablesOptions[0].selectedPhaseOption.value"
                                   :expand-no="20"
                                   :rounded-top="!multiplePhasesPresent"
                                   :show-no="5"/>

          <div v-if="multiplePhasesPresent" class="px-2 py-2.5 border-x grid grid-cols-2 gap-x-[7px] border-t rounded-t-zt border-zt-light bg-zt-light-opacity xl:gap-x-[44px]">
            <div class="basis-1/2 w-full text-xs py-[5px] text-center rounded-zt border border-zt-light flex items-center justify-center">
              <span class="opacity-30">{{ WP.team.league_season }}{{ WP.team.league_season_type === 'season' ? `/${+WP.team.league_season + 1}` : ''}}</span>
            </div>
            <div>
              <PickFilterModal
                  customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                  custom-header-classes="text-center !text-xs w-full !font-normal"
                  :options="phaseOptions"
                  :defaultOption="selectedPhaseOption.name"
                  :selectedOption="singleTablesOptions[1].selectedPhaseOption.name"
                  :showIcons="false"
                  slide-bottom-modal
                  :type="'full'"
                  @optionSelected="(option) => singleTablesOptions[1].selectedPhaseOption = phaseOptions.find(el => el.name === option)"
              />
            </div>
          </div>
          <FootballTabScorersTable class="mb-6"
                                   :players="scorers"
                                   :show-only-goals="leaguesWithoutAssists"
                                   :expand-no="20"
                                   :phase="singleTablesOptions[1].selectedPhaseOption.value"
                                   :rounded-top="!multiplePhasesPresent"
                                   :show-no="5"
                                   :table-type="'canadian'"/>

          <div v-if="multiplePhasesPresent" class="px-2 py-2.5 border-x grid grid-cols-2 gap-x-[7px] border-t rounded-t-zt border-zt-light bg-zt-light-opacity xl:gap-x-[44px]">
            <div class="basis-1/2 w-full text-xs py-[5px] text-center rounded-zt border border-zt-light flex items-center justify-center">
              <span class="opacity-30">{{ WP.team.league_season }}{{ WP.team.league_season_type === 'season' ? `/${+WP.team.league_season + 1}` : ''}}</span>
            </div>
            <div>
              <PickFilterModal
                  customClasses="bg-zt-light-opacity flex pl-4 items-center
                             border border-zt-light rounded-zt text-sm cursor-pointer relative h-[28px] xl:w-full"
                  custom-header-classes="text-center !text-xs w-full !font-normal"
                  :options="phaseOptions"
                  :defaultOption="selectedPhaseOption.name"
                  :selectedOption="singleTablesOptions[2].selectedPhaseOption.name"
                  :showIcons="false"
                  slide-bottom-modal
                  :type="'full'"
                  @optionSelected="(option) => singleTablesOptions[2].selectedPhaseOption = phaseOptions.find(el => el.name === option)"
              />
            </div>
          </div>
          <FootballTabScorersTable
              :players="scorers"
              :phase="singleTablesOptions[2].selectedPhaseOption.value"
              :show-only-goals="leaguesWithoutAssists"
              :expand-no="20"
              :rounded-top="!multiplePhasesPresent"
              :show-no="5"
              :table-type="'percentage'"/>
	      </div>
	      <div key="historia" v-else-if="activeTab === 'historia'">
	        <TeamHistory :seasonHistory="seasonHistory" :seasonsType="WP.team.league_season_type" />
	      </div>
        <div key="kadra" v-else-if="activeTab === 'kadra'">
          <p v-if="squad.length === 0"
             class="text-xs text-zt-more text-center font-normal w-full -leading-[0.18px] bg-zt-light-full py-2.5
                    rounded-zt border-zt-light border">
            Brak informacji do wyświetlenia
          </p>
	        <div v-else>
						<TeamSquad :squad="squad" />
	        </div>
        </div>
	    </Transition>
	    <FootballBets no-red-button-link show-top-border/>
	  </div>
	</Transition>
</template>

<script>
import FootballStatsList from '../../blocks/FootballStatsList.vue';
import FootballTable from '../../../sections/FootballTable.vue';
import FootballTabScorersTable from '../../blocks/FootballTabScorersTable.vue'
import H2hTable from '../tables/H2hTable.vue';
import TeamTimetable from '../tables/TeamTimetable.vue';
import TeamResultsTable from '../tables/TeamResultsTable.vue';
import TeamHistory from '../blocks/TeamHistory.vue';
import FootballBets from '../../blocks/FootballBets.vue'
import utils_mixin from "../../../mixins/utils_mixin";
import FootballStatsFilter from "../../FootballStatsFilter.vue";
import FootballLeagueTimetable from "../../../sections/FootballLeagueTimetable.vue";
import TeamSquad from "../blocks/TeamSquad.vue";
import FootballLeagueGroups from "../../../sections/FootballLeagueGroups.vue";
import Ladder from "../../football_tables/Ladder.vue";
import FootballLeagueNestedGroups from "../../../sections/FootballLeagueNestedGroups.vue";
import TeamSelectList from "../blocks/TeamSelectList.vue";
import SeasonPhaseSelect from "../../SeasonPhaseSelect.vue";
import PickFilterModal from "../../modals/PickFilterModal.vue";
import TournamentQualifications from "../../../sections/TournamentQualifications.vue";
import TeamCompareWithLastSeason from "../blocks/TeamCompareWithLastSeason.vue";

export default {
  name: 'FootballTeam',
  inject: ['WP'],
	mixins: [utils_mixin],
  components: {
    TeamCompareWithLastSeason,
    TournamentQualifications,
    PickFilterModal,
    TeamSelectList,
	  FootballLeagueNestedGroups,
    FootballLeagueGroups,
	  TeamSquad,
    FootballLeagueTimetable,
	  FootballStatsFilter,
	  TeamHistory,
    FootballStatsList,
    FootballTable,
    FootballTabScorersTable,
    H2hTable,
    TeamTimetable,
    TeamResultsTable,
    FootballBets,
    Ladder,
    SeasonPhaseSelect
  },
  data() {
    return {
      selectedPhaseOption: {name:'Cały sezon', value: 'regular', active: true},
      singleTablesOptions: [
        {
          selectedPhaseOption: {name:'Cały sezon', value: 'regular', active: true},
        },
        {
          selectedPhaseOption: {name:'Cały sezon', value: 'regular', active: true},
        },
        {
          selectedPhaseOption: {name:'Cały sezon', value: 'regular', active: true},
        }
      ],
      activeTab: '',
      lastMatches: [],
      upcomingMatches: [],
      scorers: {},
      rounds: [],
	    noOfUpcomingMatches: 3,
      seasonHistory: [],
	    noOfResults: 5,
	    selectedFilter: [],
	    filteringOptions: [
		    {
			    name: '1x2',
			    value: '1x2',
			    options: []
		    },
		    {
			    name: 'Rożne',
			    value: 'corners',
			    options: [
				    {
					    name: 'Rezultat',
					    value: 'result',
					    options: []
				    },
				    {
					    name: 'Over/Under',
					    value: 'overunder',
					    options: [
						    {
							    name: '7,5',
							    value: 7.5,
							    options: []
						    },
						    {
							    name: '8,5',
							    value: 8.5,
							    options: []
						    },
						    {
							    name: '9,5',
							    value: 9.5,
							    options: []
						    },
						    {
							    name: '10,5',
							    value: 10.5,
							    options: []
						    },
						    {
							    name: '11,5',
							    value: 11.5,
							    options: []
						    },
						    {
							    name: '12,5',
							    value: 12.5,
							    options: []
						    },
					    ]
				    }
			    ]
		    },
		    {
			    name: 'Kartki',
			    value: 'cards',
			    options: [
				    {
					    name: 'Żółte',
					    value: 'yellowcards',
					    options: [
						    {
							    name: 'Rezultat',
							    value: 'result',
							    options: []
						    },
						    {
							    name: 'Over/Under',
							    value: 'overunder',
							    options: [
								    {
									    name: '1,5',
									    value: 1.5,
									    options: []
								    },
								    {
									    name: '2,5',
									    value: 2.5,
									    options: []
								    },
								    {
									    name: '3,5',
									    value: 3.5,
									    options: []
								    },
								    {
									    name: '4,5',
									    value: 4.5,
									    options: []
								    },
								    {
									    name: '5,5',
									    value: 5.5,
									    options: []
								    },
							    ]
						    }
					    ]
				    },
				    {
					    name: 'Czerwone',
					    value: 'redcards',
					    options: [
						    {
							    name: 'Rezultat',
							    value: 'result',
							    options: []
						    },
						    {
							    name: 'Over/Under',
							    value: 'overunder',
							    options: [
								    {
									    name: '0,5',
									    value: 0.5,
									    options: []
								    },
							    ]
						    }
					    ]
				    },
			    ]
		    },
		    {
			    name: 'BTTS',
			    value: 'btts',
			    options: []
		    },
		    {
			    name: 'Over/under',
			    value: 'overunder',
			    options: [
				    {
					    name: '0,5',
					    value: 0.5,
					    options: []
				    },
				    {
					    name: '1,5',
					    value: 1.5,
					    options: []
				    },
				    {
					    name: '2,5',
					    value: 2.5,
					    options: []
				    },
				    {
					    name: '3,5',
					    value: 3.5,
					    options: []
				    },
				    {
					    name: '4,5',
					    value: 4.5,
					    options: []
				    },
				    {
					    name: '5,5',
					    value: 5.5,
					    options: []
				    },
			    ]
		    },
		    {
			    name: 'Połowy',
			    value: 'halfs',
			    options: [
				    {
					    name: '1. Połowa',
					    value: 'firsthalf',
					    options: []
				    },
				    {
					    name: '2. Połowa',
					    value: 'secondhalf',
					    options: []
				    },
			    ]
		    },
		    {
			    name: 'Karne',
			    value: 'penalty',
			    options: [
				    {
					    name: 'Gole Z Karnych',
					    value: 'inmatch',
					    options: []
				    },
			    ]
		    },
	    ],
	    resultsRounds: [],
	    squad: [],
	    loading: true,
	    euroAndCopaTeamIds: [ // Euro 2024 + Argentyna, Brazylia, Kolumbia, Urugwaj
		    25, 769, 1108, 15, 778, 3, 768, 9, 21, 10, 14, 1091, 775, 2, 1118, 24, 1, 774, 773, 772, 770, 1104, 27, 777, 26, 6, 8, 7
	    ],
      selectOpen: false,
      selected_phase: {name:'Bramki / asysty', value: 'normal', active: true},
      options: [
          {name:'Bramki / asysty', value: 'normal', active: true},
          {name:'Punktacja kanadyjska', value: 'canadian', active: true},
          {name:'Udział zawodnika w bramkach drużyny (B+A)', value: 'percentage', active: true}
      ],
      highlightedLeaguesIds: [78, 106, 140, 61, 39, 135, 88],
    }
  },
  computed: {
    multiplePhasesPresent() {
      if (this.loading) {
        return false;
      }
      return this.scorers.championship.length > 0 || this.scorers.relegation.length > 0 || this.scorers.conference.length > 0;
    },
    phaseOptions() {
      let options = [];
      const names = {
        'regular': 'Cały sezon',
        'championship': 'Grupa Mistrzowska',
        'relegation': 'Grupa Spadkowa',
        'conference': 'Grupa Ligi Konferencji'
      };
      Object.keys(names).forEach(key => {
        if (this.scorers[key].length > 0) {
          options.push({name: names[key], value: key, active: true});
        }
      })
      return options;
    },
    teamsOtherLeagues() {
      return this.WP.team.other_leagues_ids;
    },
    statsListLeague() {
      return {
        league_name: this.WP.team.league,
        country_name: this.WP.team.country_polish_name,
        league_query_name: this.WP.team.league_query_name,
        country_query_name: this.WP.team.country_query_name,
      };
    },
    leaguesWithoutAssists() {
      return [108, 47, 318, 172, 107, 310, 342, 419, 315, 408, 373, 355, 371, 283, 329, 327, 362, 107].includes(Number(this.WP.team.league_id))
    },
  },
	mounted() {
    let tab = 'przegląd';
    let lastPathnameElement = window.location.pathname.split('/').at(-2);
    const availableTabs = ['przeglad', 'tabela', 'wyniki', 'terminarz', 'strzelcy', 'historia', 'kadra'];
    if (availableTabs.includes(lastPathnameElement)) {
      tab = lastPathnameElement;
    }

    if (tab !== 'przegląd') {
      this.changeTab(tab);
    } else {
      this.activeTab = tab;
      if (lastPathnameElement === 'przeglad') {
        let urlWithoutLastElement = window.location.href.substring(0, window.location.href.lastIndexOf('/', window.location.href.length - 2) + 1);
        window.history.replaceState(null, '', urlWithoutLastElement);
      }
    }
		const resMatches = axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_team_matches',
			team_id: this.WP.team.team_id,
			league_id: this.WP.team.league_id,
		}).then(resp => this.lastMatches = resp.data.data[0]);

		const resScorers = axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_team_scorers',
			team_id: this.WP.team.team_id,
			league_id: this.WP.team.league_id,
		}).then(resp => this.scorers = resp.data.data);

		const resSchedule = axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_team_schedule',
			team_id: this.WP.team.team_id,
		}).then(resp => {
			this.rounds = resp.data.data;
			Object.values(this.rounds).forEach(round => {
				this.upcomingMatches.push(...round.round_matches);
			})
		})
		const resHistory = axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_team_history',
			team_id: this.WP.team.team_id,
		}).then(resp => this.seasonHistory = resp.data.data);

	  const resRound = axios.post(this.WP.ajaxUrl, {
		  endpoint: 'api_get_team_results',
		  team_id: this.WP.team.team_id,
		}).then(resp =>  this.resultsRounds = resp.data.data);

		const resSquad = axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_team_squad',
			team_id: this.WP.team.team_id
		}).then(resp => this.squad = resp.data.data);

	  Promise.all([resMatches, resScorers, resSchedule, resHistory, resRound, resSquad]).then(() => {
			if (webSocketsEnabled) {
				this.addWSListeners();
			}
			this.emitter.on('football-nav-tab-changed', this.changeTab);
      this.loading = false;
      this.removePlaceholder(this.$attrs.component);
      loadScrollPositionState(window.location.pathname);
		});
  },
  methods: {
    onSelectedOption(option) {
      this.unblockScrolling();
      this.selectedOption = option;
      this.selectOpen = false;
    },
    changeTab(tab) {
      if (this.activeTab === 'przegląd' && tab !== 'przegląd') {
        window.history.replaceState(null, '', `${window.location.href}${tab}/`);
      } else if (this.activeTab !== 'przegląd' && tab === 'przegląd') {
        window.history.replaceState(null, '', `${window.location.href.substring(0, window.location.href.lastIndexOf('/', window.location.href.length - 2) + 1)}`);
      } else {
        window.history.replaceState(null, '', `${window.location.href.substring(0, window.location.href.lastIndexOf('/', window.location.href.length - 2) + 1)}${tab}/`);
      }
      this.activeTab = tab;
      let h1Element = document.querySelector('#team-page-h1');
      if (WP.team?.country === 'World') {
        h1Element.innerHTML = `${WP.team.team_short_name ? WP.team.team_short_name : WP.team.name}
          - ${tab === 'przegląd' ? 'reprezentacja' : tab}
          ${(this.activeTab === 'strzelcy' || this.activeTab === 'kadra') && WP.team.league_query_name === 'euro' ? '(EURO 2024)' : ''}`;
      } else {
        h1Element.innerHTML = `${WP.team.team_short_name ? WP.team.team_short_name : WP.team.name} - ${tab}`;
      }
      this.emitter.emit('change-football-nav-tab', tab);
    },
    addWSListeners() {
      socket?.on('live-matches', data => {
        data.forEach(match => {
          let index = this.lastMatches.findIndex(el => Number(el.match_id) === Number(match.match_id));
          if (index !== -1) {
            this.lastMatches[index].localteam_goals = match.localteam_goals;
            this.lastMatches[index].visitorteam_goals = match.visitorteam_goals;
            this.lastMatches[index].elapsed = match.elapsed;
            this.lastMatches[index].status = match.status;
            this.lastMatches[index].localteam_red_cards = match.localteam_red_cards;
            this.lastMatches[index].visitorteam_visitor_cards = match.visitorteam_visitor_cards;
          }
        })
      });
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  z-index: 10;
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  z-index: 10;
  opacity: 0;
}
</style>